import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import {Field, reduxForm} from 'redux-form'

import {getPromotionCodeForm} from '../../selectors/Forms'
import * as Errors from '../../constants/Errors'
import {queryPromotionCodeStatusAndData} from "../../actions/PromotionCode";
import {getInitialPromotionCode} from "../../selectors/SimpleSelectors";
import {delve} from "../../util/util";


function PromotionCodeForm(props) {
    return (
        <form disabled={props.hasInitialPromotionCode ? true : false} autoComplete="off" onSubmit={props.onSubmit}>
            <div className={"promotion-code-box__input-wrapper" + (props.isSubmitting ? " submitting" : "")}>
                <Field disabled={props.hasInitialPromotionCode} onChange={props.hasInitialPromotionCode ? null : props.onChange} name={"promotionCode"} type="text" component="input" placeholder="Aktionscode eingeben"/>
            </div>
        </form>
    );
}

PromotionCodeForm.propTypes = {
    isSubmitting: PropTypes.bool,
    isValid: PropTypes.bool,
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    hasInitialPromotionCode: PropTypes.bool
};

PromotionCodeForm.defaultProps = {
    onSubmit: (e) => {
        e.preventDefault()
    }
};

PromotionCodeForm = reduxForm({form: 'promotionCodeForm', destroyOnUnmount: false})(PromotionCodeForm)// eslint-disable-line

class PromotionCodeBox extends Component {

    static propTypes = {}

    constructor(props) {
        super(props)
        this.state = {
            callbackTimeout: false
        }
    }

    handlePromotionCodeInputChange = (e) => {

        if (this.state.callbackTimeout) {
            clearTimeout(this.state.callbackTimeout)
        }

        this.setState({
            callbackTimeout: setTimeout(() => {
                if (!this.props.promotionFormSyncErrors) {

                    this.props.queryPromotionCodeStatusAndData()
                    this.setState({callbackTimeout: false})
                }
            }, 350)
        })


    }

    handlePromotionCodeFormSubmit = (e) => {

        e.preventDefault()

    }

    getFormatedErrorMessage = (errorMessage) => {

        switch (errorMessage) {

            default:
            case Errors.PROMOTION_CODE_INVALID:
                return "Dieser Aktionscode ist leider nicht gültig!"

            case Errors.PROMOTION_CODE_FALSE_ARTICLES:
                return "Der Aktionscode bezieht sich leider nicht auf Artikel in deinem Warenkorb!"

            case Errors.PROMOTION_CODE_MONTHLY:
                return "Der Gutscheincode kann nicht bei monatlicher Vertagslaufzeit verwendet werden."

        }

    }

    render() {

        let errorClass = ""
        let errorText = null

        let successText = null

        if (!this.props.promotionCodeSubmitting && this.props.promotionCodeEntered && !this.props.promotionFormSyncErrors && !this.state.callbackTimeout) {
            errorClass = " promotion-code-box--" + (this.props.validatedPromotionCode ? "success" : "error")

            if (this.props.promotionCodeErrorStatus === 404 || this.props.promotionCodeErrorStatus === 400) {
                errorText = <div key={this.props.promotionCodeErrorStatus} className="promotion-code-box__error-message">{this.getFormatedErrorMessage(this.props.promotionCodeErrorMessage)}</div>
            } else if (delve(this.props.promotionCodeInformation, 'description')) {
                successText = <div className="promotion-code-box__success-message">{delve(this.props.promotionCodeInformation, 'description')}</div>
            }
        }

        return (
            <div className={"promotion-code-box" + errorClass}>
                <PromotionCodeForm
                    onSubmit={this.handlePromotionCodeFormSubmit}
                    onChange={this.handlePromotionCodeInputChange}
                    codeEntered={this.props.promotionCodeEntered}
                    codeValidated={this.props.validatedPromotionCode}
                    hasInitialPromotionCode={this.props.initialPromotionCode ? true : false}
                />
                {errorText}
                {successText}
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        promotionCodeInformation: state.promotionCode.codeInformation,
        promotionCodeErrorStatus: state.promotionCode.errorStatus,
        promotionCodeErrorMessage: state.promotionCode.errorMessage,
        promotionCodeSubmitting: state.promotionCode.isSubmitting,
        promotionFormSyncErrors: !!(getPromotionCodeForm(state) && getPromotionCodeForm(state).syncErrors),
        validatedPromotionCode: state.promotionCode.validatedPromotionCode,
        promotionCodeEntered: (getPromotionCodeForm(state) && getPromotionCodeForm(state).values) ? getPromotionCodeForm(state).values.promotionCode : "",
        initialPromotionCode: getInitialPromotionCode(state)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        queryPromotionCodeStatusAndData: () => {
            dispatch(queryPromotionCodeStatusAndData())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PromotionCodeBox)


/** WEBPACK FOOTER **
 ** ./src/containers/cart/PromotionCodeBox.js
 **/